export default "__VITE_ASSET__CcUzL4pQ__"